
import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center bg-gradient-to-br from-white via-cyan-50/30 to-cyan-100/20">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="inline-block px-6 py-2 bg-cyan-100 text-cyan-700 rounded-full text-sm font-medium whitespace-nowrap">
              逗子・葉山の訪問介護
            </div>

            <div className="relative h-[400px] lg:h-[600px] rounded-3xl overflow-hidden shadow-xl lg:hidden">
              <img
                src="https://static.readdy.ai/image/4e28e17ba4e737ad2b4d0213d4252ea8/6ec6dac85b4e39052c965b6c272e6b82.png"
                alt="まごころヘルパーの介護風景"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <h1 className="text-5xl lg:text-6xl font-bold leading-tight text-gray-900">
              一人ひとりの暮らしに、
              <br />
              <span className="text-cyan-600">まごころを</span>
            </h1>

            <p className="text-xl text-gray-600 leading-relaxed">
              作業ではなく、寄り添う介護を大切にしています
            </p>

            <div className="flex flex-wrap gap-4 pt-4">
              <Link
                to="/recruit"
                className="inline-flex items-center gap-2 px-8 py-4 bg-cyan-500 text-white rounded-full font-medium text-lg hover:bg-cyan-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                採用情報を見る
                <i className="ri-arrow-right-line text-xl"></i>
              </Link>
              <Link
                to="/service"
                className="inline-flex items-center gap-2 px-8 py-4 bg-white text-cyan-600 border-2 border-cyan-500 rounded-full font-medium text-lg hover:bg-cyan-50 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                サービス内容
              </Link>
            </div>
          </div>

          <div className="relative h-[600px] rounded-3xl overflow-hidden shadow-xl hidden lg:block">
            <img
              src="https://static.readdy.ai/image/4e28e17ba4e737ad2b4d0213d4252ea8/6ec6dac85b4e39052c965b6c272e6b82.png"
              alt="まごころヘルパーの介護風景"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
